import "./LoyaltyHistoryTable.scss";
import { Table, TableProps } from "antd";
import React, { useMemo, useState } from "react";
import { ILoyaltyHistory } from "../../../models/Loyalty";
import { useTranslation } from "react-i18next";
import LoyaltyHistoryPopupTable from "../LoyaltyHistoryPopupTable/LoyaltyHistoryPopupTable";
import { useGetLoyaltyHistoryQuery } from "../../../api/queries";

type ColumnsType<T> = TableProps<T>["columns"];

const LoyaltyHistoryTable = () => {
  const { t } = useTranslation();

  const [tableParams, setTableParams] = useState<{ skip: number; pageSize: number }>({
    skip: 0,
    pageSize: 7,
  });
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);

  const { data = { historyItemsLength: 0, historyItems: [] }, isLoading } =
    useGetLoyaltyHistoryQuery({
      userId: null,
      skip: tableParams.skip,
      limit: tableParams.pageSize,
    });

  const totalCount = useMemo(() => {
    if (!data) return 0;
    return data.historyItemsLength;
  }, [data]);

  const closePopup = () => {
    setSelectedUserId(null);
  };

  const handleTableChange: TableProps<ILoyaltyHistory>["onChange"] = (pagination) => {
    const current = pagination.current || 1;
    const pageSize = pagination.pageSize || 7;
    const skip = current && pageSize ? (current - 1) * pageSize : 0;
    setTableParams({
      pageSize,
      skip,
    });
  };

  const columns: ColumnsType<ILoyaltyHistory> = [
    {
      title: t("FirstName"),
      dataIndex: "firstname",
    },
    {
      title: t("LastName"),
      dataIndex: "lastname",
    },
    {
      title: t("Email"),
      dataIndex: "email",
    },
    {
      title: t("NumberOfPoints"),
      dataIndex: "numberOfPoints",
    },
    {
      title: t("Action"),
      render: (data: ILoyaltyHistory) => {
        return (
          <button
            type={"button"}
            className={"see-details"}
            onClick={() => setSelectedUserId(data.userId)}
          >
            {t("SeeDetails")}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <g clipPath="url(#clip0_19435_12996)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.24399 5.24417C5.40026 5.08795 5.61219 5.00018 5.83316 5.00018C6.05413 5.00018 6.26605 5.08795 6.42232 5.24417L10.589 9.41084C10.7452 9.56711 10.833 9.77904 10.833 10C10.833 10.221 10.7452 10.4329 10.589 10.5892L6.42232 14.7558C6.26515 14.9076 6.05465 14.9916 5.83615 14.9897C5.61766 14.9878 5.40865 14.9002 5.25414 14.7457C5.09963 14.5912 5.01199 14.3822 5.01009 14.1637C5.00819 13.9452 5.09219 13.7347 5.24399 13.5775L8.82149 10L5.24399 6.42251C5.08776 6.26623 5 6.05431 5 5.83334C5 5.61237 5.08776 5.40045 5.24399 5.24417ZM10.244 5.24417C10.4003 5.08795 10.6122 5.00018 10.8332 5.00018C11.0541 5.00018 11.266 5.08795 11.4223 5.24417L15.589 9.41084C15.7452 9.56711 15.833 9.77904 15.833 10C15.833 10.221 15.7452 10.4329 15.589 10.5892L11.4223 14.7558C11.2652 14.9076 11.0547 14.9916 10.8362 14.9897C10.6177 14.9878 10.4086 14.9002 10.2541 14.7457C10.0996 14.5912 10.012 14.3822 10.0101 14.1637C10.0082 13.9452 10.0922 13.7347 10.244 13.5775L13.8215 10L10.244 6.42251C10.0878 6.26623 10 6.05431 10 5.83334C10 5.61237 10.0878 5.40045 10.244 5.24417Z"
                  fill="#101016"
                />
              </g>
              <defs>
                <clipPath id="clip0_19435_12996">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </button>
        );
      },
    },
  ];

  return (
    <>
      <Table
        className={"loyalty-history-table"}
        columns={columns}
        rowKey={(record) => record.id}
        dataSource={data.historyItems}
        pagination={{ ...tableParams, total: totalCount }}
        loading={isLoading}
        onChange={handleTableChange}
      />
      {selectedUserId && <LoyaltyHistoryPopupTable userId={selectedUserId} close={closePopup} />}
    </>
  );
};

export default LoyaltyHistoryTable;
